import { useEffect, useState } from "react";
import useOrderItemsFromApiStore from "../store/orderItemsFromApiStore";
import plusIcon from "../assets/plusIcon.png";
import { FaMinusSquare } from "react-icons/fa";
import useOrderItemsLoadStore from "../store/orderItemsLoadStore";
import api from "../services/api";
import { useParams } from "react-router-dom";

const EditOrderLoadItem = ({ setRemovedOrderLoadItemsDetailsFixed }) => {
  const { orderItemsFromApi, getAllOrderItemsFromApi } =
    useOrderItemsFromApiStore();
  const {
    orderItemsLoad,
    addOrderItemLoad,
    clearOrderItemsLoad,
    removeOrderLoadItem,
    updateOrderItemLoad,
  } = useOrderItemsLoadStore();
  const [selectedItem, setSelectedItem] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unitValue, setUnitValue] = useState("");
  const [targetValue, setTargetValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [orderLoadItems, setOrderLoadItems] = useState([]);
  const [cmv, setCmv] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    getAllOrderItemsFromApi();
  }, [getAllOrderItemsFromApi]);

  useEffect(() => {
    const fetchOrderLoadItems = async () => {
      try {
        const response = await api.get(`/order-load-items/order/id/${id}`);

        setOrderLoadItems(response.data);
      } catch (error) {
        console.error("Error fetching order load:", error);
      }
    };
    fetchOrderLoadItems();
  }, [id]);

  useEffect(() => {
    clearOrderItemsLoad();
    for (const orderLoadItem of orderLoadItems) {
      const quantity = orderLoadItem.quantity;

      const {
        averageTargetValue,
        averageUnitValue,
        averageDollarCost,
        priceAndQuantity,
      } = calculateProductPrice(quantity, orderLoadItem);

      const newItem = {
        order_load_item_id: orderLoadItem.id, //uso aqui para saber se o item veio do banco ou nao. se veio e for removido, preciso atualizar os correspondentes no backend.
        order_item_id: orderLoadItem.order_item_id,
        name: orderLoadItem.name,
        quantity: parseInt(orderLoadItem.quantity, 10),
        target_value: parseFloat(averageTargetValue).toFixed(2),
        unit_value: parseFloat(averageUnitValue).toFixed(2),
        total_value: (
          orderLoadItem.quantity * orderLoadItem.target_value
        ).toFixed(2),
        average_dollar_cost: averageDollarCost,
        total_value_in_real: orderLoadItem.total_value_in_real,
        orderItemsDetails: priceAndQuantity,
        orderItemsDetailsFixed: priceAndQuantity,
      };

      addOrderItemLoad(newItem);
    }
  }, [orderLoadItems, setOrderLoadItems]);

  useEffect(() => {
    const cmv = orderItemsLoad.reduce((acc, item) => {
      return acc + Number(item.target_value * item.quantity);
    }, 0);
    setCmv(cmv.toLocaleString("pt-BR", { style: "currency", currency: "USD" }));
  }, [orderItemsLoad]);

  const calculateProductPrice = (quantity, item) => {
    const priceAndQuantity = [];
    let myQuantity = Number(quantity);

    let currentQuantity = 0;

    const clonedItem = [...item.orderItemsDetails];

    for (const item of clonedItem) {
      if (currentQuantity < myQuantity) {
        const remainingSpace = myQuantity - currentQuantity;

        if (item.remaining_quantity > remainingSpace) {
          priceAndQuantity.push({
            ...item,
            remaining_quantity: remainingSpace,
          });
          currentQuantity += remainingSpace;
          break;
        } else {
          priceAndQuantity.push(item);
          currentQuantity += item.remaining_quantity;
        }
      }
    }

    let totalSumTargetValue = 0;
    let totalSumUnitValue = 0;
    let totalSumDollarCost = 0;
    let totalQuantity = 0;
    let totalValue = 0;

    for (const item of priceAndQuantity) {
      totalSumTargetValue += item.remaining_quantity * item.target_value;
      totalSumUnitValue += item.remaining_quantity * item.unit_value;

      totalSumDollarCost +=
        item.remaining_quantity *
        item.target_value *
        item.order.average_dollar_cost;
      totalValue += item.remaining_quantity * item.target_value;
      totalQuantity += parseFloat(item.remaining_quantity);
    }

    const averageTargetValue = totalSumTargetValue / totalQuantity;
    const averageUnitValue = totalSumUnitValue / totalQuantity;
    const averageDollarCost = totalSumDollarCost / totalValue;

    if (totalQuantity < myQuantity) {
      alert(`Quantidade máxima disponível: ${totalQuantity}`);
      if (item === selectedItem) {
        setQuantity(totalQuantity);
      } else {
        item.quantity = totalQuantity;
      }
    }

    return {
      averageTargetValue,
      averageUnitValue,
      averageDollarCost,
      priceAndQuantity,
    };
  };

  useEffect(() => {
    if (!selectedItem) return;

    const { averageTargetValue, averageDollarCost, priceAndQuantity } =
      calculateProductPrice(quantity, selectedItem);

    setTargetValue(averageTargetValue?.toFixed(2) || "");
    setUnitValue(averageTargetValue?.toFixed(2));

    setSelectedItem((state) => ({
      ...state,
      averageDollarCost,
      orderItemsInfo: priceAndQuantity,
    }));
  }, [quantity]);

  const onHandleAddOrderLoadItems = () => {
    if (!selectedItem.id || !quantity || !targetValue || !unitValue) {
      setErrorMessage("Por favor, preencha todos os campos");
      return;
    }

    const existingItem = orderItemsLoad
      .filter((item) => item.name === selectedItem.product_name)
      .at(0);

    if (existingItem) {
      alert("A carga já possui esse produto adicionado!");
      return;
    }

    setErrorMessage("");
    const newItem = {
      order_item_id: selectedItem.id,
      name: selectedItem.product_name,
      quantity: parseInt(quantity, 10),
      target_value: parseFloat(targetValue).toFixed(2),
      unit_value: parseFloat(unitValue).toFixed(2),
      total_value: (quantity * targetValue).toFixed(2),
      average_dollar_cost: selectedItem.averageDollarCost.toFixed(2),
      total_value_in_real: (
        selectedItem.averageDollarCost *
        (quantity * unitValue)
      ).toFixed(2),
      orderItemsDetails: selectedItem.orderItemsInfo,
      type: "added",
    };

    addOrderItemLoad(newItem);

    setSelectedItem("");
    setQuantity("");
    setTargetValue("");
    setUnitValue("");
  };

  const handleInputChange = (index, field, value) => {
    const orderItemId = orderItemsLoad[index].order_item_id;
    const orderLoadItemWithCorrectAmount = orderLoadItems
      .filter((item) => item.order_item_id === orderItemId)
      .at(0);

    const updatedItem = {
      ...orderItemsLoad[index],
      ...(field ? { [field]: value } : value),
      ...(orderLoadItemWithCorrectAmount && {
        orderItemsDetails: orderLoadItemWithCorrectAmount.orderItemsDetails,
      }),
    };

    if (updatedItem.type === "added") {
      const orderItemFromApi = orderItemsFromApi.find(
        (item) => item.id === parseInt(updatedItem.order_item_id)
      );

      updatedItem.orderItemsDetails = orderItemFromApi.orderItemsDetails;
    }

    const {
      averageTargetValue,
      averageDollarCost,
      priceAndQuantity,
      averageUnitValue,
    } = calculateProductPrice(updatedItem.quantity, updatedItem);

    updatedItem.target_value = averageTargetValue.toFixed(2);
    updatedItem.unit_value = averageUnitValue.toFixed(2); //TODO: ver sobre calculo do valor unitário. se tem q ratear ou nao.

    updatedItem.total_value =
      parseFloat(updatedItem.target_value) * parseInt(updatedItem.quantity);

    updatedItem.total_value_in_real = (
      parseFloat(updatedItem.target_value) *
      parseInt(updatedItem.quantity) *
      averageDollarCost
    ).toFixed(2);

    updateOrderItemLoad(index, {
      ...updatedItem,
      averageDollarCost,
      orderItemsDetails: priceAndQuantity,
    });
  };

  const handleRemoveOrderLoadItem = (index) => {
    const orderLoadItem = orderItemsLoad
      .filter((_, itemIndex) => itemIndex === index)
      .at(0);

    removeOrderLoadItem(index);

    if (orderLoadItem.order_load_item_id) {
      setRemovedOrderLoadItemsDetailsFixed((state) => [
        ...state,
        orderLoadItem.orderItemsDetailsFixed,
      ]);
    }
  };

  return (
    <>
      <div className="bg-[#F2F2F2] rounded-md px-4 pb-4 pt-8 mt-4 min-h-[330px] text-boldGray opacity-90">
        <div className="space-y-4">
          {orderItemsLoad.map((orderItemLoad, index) => {
            const orderItemId = orderItemsFromApi
              .filter(
                (item) =>
                  item.product_name ===
                  orderItemLoad.orderItemsDetails[0]?.product.name
              )
              .at(0)?.id;

            return (
              <div
                key={index}
                className="bg-[#E7E7E7] p-4 rounded-md shadow-md flex flex-wrap gap-4"
              >
                <div className="flex-[0.6]">
                  <label className="block mb-1 font-semibold">Índice</label>
                  <input
                    type="number"
                    value={index + 1}
                    readOnly
                    className="w-full border rounded p-2 bg-gray-200"
                  />
                </div>
                <div className="flex-1">
                  <label className="block mb-1 font-semibold">Item</label>
                  <select
                    id="productSelect"
                    value={orderItemId || ""}
                    onChange={(e) => {
                      const selectedProduct = orderItemsFromApi.find(
                        (orderItem) => orderItem.id === parseInt(e.target.value)
                      );

                      handleInputChange(index, null, {
                        order_item_id: selectedProduct?.id || "",
                        name: selectedProduct?.product_name || "",
                      });
                    }}
                    className="w-full p-2"
                  >
                    <option value="" disabled>
                      Selecione um produto
                    </option>
                    {orderItemsFromApi.map((orderItem) => (
                      <option key={orderItem.id} value={orderItem.id}>
                        {orderItem.product_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex-1">
                  <label className="block mb-1 font-semibold">Quantidade</label>
                  <input
                    type="number"
                    value={orderItemLoad.quantity || ""}
                    onChange={(e) =>
                      handleInputChange(
                        index,
                        "quantity",
                        parseInt(e.target.value)
                      )
                    }
                    className="w-full border rounded p-2"
                  />
                </div>
                <div className="flex-1">
                  <label className="block mb-1 font-semibold">Valor alvo</label>
                  <input
                    readOnly
                    value={orderItemLoad.target_value || ""}
                    onChange={(e) =>
                      handleInputChange(index, "target_value", e.target.value)
                    }
                    className="w-full border rounded p-2  bg-gray-200"
                  />
                </div>
                <div className="flex-1">
                  <label className="block mb-1 font-semibold">
                    Valor unitário
                  </label>
                  <input
                    readOnly
                    value={orderItemLoad.unit_value || ""}
                    onChange={(e) =>
                      handleInputChange(index, "unit_value", e.target.value)
                    }
                    className="w-full border rounded p-2  bg-gray-200"
                  />
                </div>
                <div className="flex-1">
                  <label className="block mb-1 font-semibold">Total</label>
                  <input
                    type="text"
                    value={(
                      (orderItemLoad.quantity || 0) *
                      (orderItemLoad.target_value || 0)
                    ).toFixed(2)}
                    readOnly
                    className="w-full border rounded p-2 bg-gray-200"
                  />
                </div>
                <div className="flex-1">
                  <label className="block mb-1 font-semibold">
                    Custo em R$
                  </label>
                  <input
                    type="text"
                    value={orderItemLoad.total_value_in_real}
                    readOnly
                    className="w-full border rounded p-2 bg-gray-200"
                  />
                </div>
                <div className="">
                  <button
                    onClick={() => handleRemoveOrderLoadItem(index)}
                    className="bg-red-500 text-white rounded px-4 py-2 mt-6"
                    type="button"
                  >
                    Remover
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        <div className="overflow-x-auto max-w-[1560px] custom-scrollbar"></div>
        <div className="w-full">
          <div className="h-[20px]"></div>
          <div className="bg-white text-center h-[60px] rounded-md flex flex-wrap md:text-xs xl:text-base">
            <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
              <select
                id="productSelect"
                value={selectedItem?.id || ""}
                onChange={(e) => {
                  const product = orderItemsFromApi.find(
                    (item) => item.id === parseInt(e.target.value)
                  );
                  setSelectedItem(product);
                }}
              >
                <option value="" disabled>
                  Selecione um produto
                </option>
                {orderItemsFromApi.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.product_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
              <input
                placeholder="Quantidade"
                type="text"
                className="text-center focus:outline-none w-full"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              />
            </div>
            <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
              <input
                placeholder="Valor alvo"
                type="text"
                value={targetValue}
                readOnly
                className="text-center focus:outline-none w-full"
              />
            </div>
            <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
              <input
                placeholder="Valor unitário"
                type="text"
                value={unitValue}
                readOnly
                className="text-center focus:outline-none w-full"
              />
            </div>

            <div className="flex justify-center items-center py-4 px-2">
              <button
                className="flex justify-center items-center"
                type="button"
                onClick={() => onHandleAddOrderLoadItems()}
              >
                <img src={plusIcon} alt="Adicionar" />
              </button>
            </div>
            <div className="w-[20px]"></div>
          </div>
          {errorMessage && (
            <p className="text-center pt-4 text-red-500">{errorMessage}</p>
          )}
        </div>
      </div>
    </>
  );
};

export default EditOrderLoadItem;
